<template>
	<div id="weightment-main">
		<div class="row">
			<div class="col-sm-12">
				<div class="row mb-1">
					<div class="col-sm-7">
						<div class="d-flex align-items-center mb-2">
							<h4 class="m-0 me-4">WEIGHTMENT</h4>
							<a id="add_weightment_btn" class="btn btn-success btn-sm" href="#" role="button" data-bs-toggle="modal" data-bs-target="#addWeightmentModal" v-if="['110', '111'].indexOf(all_permissions) >= 0">ADD</a>
						</div>
					</div>
				</div>
				<DataTableComponent :dataprops="dataprops" @view-object="viewWeightment" @upload-object="uploadImages" @duplicate-object="duplicateObject" @print-object="printWeightment" @edit-object="prepareEditWeightment" @toggle-object-status="toggleWeightment"></DataTableComponent>
			</div>
		</div>
		<div class="modal fade" ref="addEditModal" id="addWeightmentModal" tabindex="-1" aria-labelledby="addWeightmentModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="addWeightmentModalLabel">ADD Weightment</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancelAddEdit"></button>
					</div>
					<div class="modal-body">
						<div class="row mb-4">
							<div class="col-3 text-end">
								<label for="add_weightment_ref_no" class="form-label text-uppercase fw-bold mb-0 mt-2 me-3">Ref No</label
								><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
							</div>
							<div class="col-3">
								<div>
									<input type="text" class="form-control" v-model="weightmentForAdd.ref_no" id="add_weightment_ref_no" placeholder="AUTOGENERATED" readonly />
								</div>
							</div>
							<div class="col-3 text-end">
								<label for="add_weightment_company_id" class="form-label text-uppercase fw-bold mb-0 mt-2 me-3">Company <span class="mandatory">*</span></label>
							</div>
							<div class="col-3">
								<div>
									<select class="form-select" v-model="weightmentForAdd.company_id" id="add_company_id">
										<optgroup v-if="allCompanyIdList" label="Choose Company">
											<template v-for="companyId in allCompanyIdList" :key="companyId.id">
												<option :value="companyId.id">{{ companyId.name }}</option>
											</template>
										</optgroup>
									</select>
								</div>
								<template v-for="error of v$.weightmentForAdd.company_id.$errors" :key="error.$uid">
									<div class="mandatory mb-1">{{ error.$message }}</div>
								</template>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-12 d-flex flex-row align-items-center gap-3">
								<label for="add_weightment_customer_id" class="form-label text-uppercase fw-bold mb-0 flex-shrink-0">To Customer <span class="mandatory">*</span></label>
								<div>
									<multiselect v-model="weightmentForAdd.customer_id" :options="allCustomerIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
								</div>
								<div>
									<label for="add_weightment_subject" class="form-label text-uppercase fw-bold mb-0 me-2">Subject</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div>
									<input type="text" class="form-control" v-model="weightmentForAdd.subject" id="add_weightment_subject" placeholder="Enter Subject" />
								</div>
								<label for="add_weightment_subject" class="form-label text-uppercase fw-bold mb-0 me-3">General Structural Condition</label>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-8 d-flex text-right align-items-center">
								<span class="me-2">1.</span>
								<input type="text" class="form-control" v-model="weightmentForAdd.field_1_key" id="add_weightment_field_1_key" />
							</div>
							<div class="col-2">
								<input type="text" class="form-control" v-model="weightmentForAdd.field_1_value_1" id="add_weightment_field_1_value_1" />
							</div>
							<div class="col-2">
								<input type="text" class="form-control" v-model="weightmentForAdd.field_1_value_2" id="add_weightment_field_1_value_2" />
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-8 d-flex text-right align-items-center">
								<span class="me-2">2.</span>
								<input type="text" class="form-control" v-model="weightmentForAdd.field_2_key" id="add_weightment_field_2_key" />
							</div>
							<div class="col-2">
								<input type="text" class="form-control" v-model="weightmentForAdd.field_2_value_1" id="add_weightment_field_2_value_1" />
							</div>
							<div class="col-2">
								<input type="text" class="form-control" v-model="weightmentForAdd.field_2_value_2" id="add_weightment_field_2_value_2" />
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-8 d-flex text-right align-items-center">
								<span class="me-2">3.</span>
								<input type="text" class="form-control" v-model="weightmentForAdd.field_3_key" id="add_weightment_field_3_key" />
							</div>
							<div class="col-2">
								<input type="text" class="form-control" v-model="weightmentForAdd.field_3_value_1" id="add_weightment_field_3_value_1" />
							</div>
							<div class="col-2">
								<input type="text" class="form-control" v-model="weightmentForAdd.field_3_value_2" id="add_weightment_field_3_value_2" />
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-8 d-flex text-right align-items-center">
								<span class="me-2">4.</span>
								<input type="text" class="form-control" v-model="weightmentForAdd.field_4_key" id="add_weightment_field_4_key" />
							</div>
							<div class="col-2">
								<input type="text" class="form-control" v-model="weightmentForAdd.field_4_value_1" id="add_weightment_field_4_value_1" />
							</div>
							<div class="col-2">
								<input type="text" class="form-control" v-model="weightmentForAdd.field_4_value_2" id="add_weightment_field_4_value_2" />
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-8 d-flex text-right align-items-center">
								<span class="me-2">5.</span>
								<input type="text" class="form-control" v-model="weightmentForAdd.field_5_key" id="add_weightment_field_5_key" />
							</div>
							<div class="col-2">
								<input type="text" class="form-control" v-model="weightmentForAdd.field_5_value_1" id="add_weightment_field_5_value_1" />
							</div>
							<div class="col-2">
								<input type="text" class="form-control" v-model="weightmentForAdd.field_5_value_2" id="add_weightment_field_1_value_2" />
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-3 text-end">
								<label for="add_weightment_comments" class="form-label text-uppercase fw-bold mb-0 me-3">Comments</label
								><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
							</div>
							<div class="col-9">
								<div>
									<textarea class="form-control" v-model="weightmentForAdd.comments" id="add_weightment_comments" placeholder="Enter Comments"></textarea>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-3 text-end">
								<label for="add_weightment_surveyor_id" class="form-label text-uppercase fw-bold mb-0 me-3">Surveyor </label>
							</div>
							<div class="col-3">
								<div>
									<multiselect v-model="weightmentForAdd.surveyor_id" :options="allSurveyorIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-3 text-end">
								<label for="add_weightment_date_of_issue" class="form-label text-uppercase fw-bold mb-0 me-3">Date Of Issue</label>
							</div>
							<div class="col-3">
								<div>
									<input type="date" class="form-control" v-model="weightmentForAdd.date_of_issue" id="add_weightment_date_of_issue" placeholder="Enter Date Of Issue" />
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-dark btn-sm" data-bs-dismiss="modal" @click="cancelAddEdit()">CLOSE</button>
						<button type="button" class="btn btn-dark btn-sm" @click="saveWeightment()">SAVE CHANGES</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" ref="readModal" id="readWeightmentModal" tabindex="-1" aria-labelledby="readWeightmentModalLabel" aria-hidden="true" v-if="readWeightment">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="readWeightmentModalLabel">View Weightment</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancelAddEdit"></button>
					</div>
					<div class="modal-body">
						<div class="row mb-4">
							<div class="col-3 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Ref No</label>
							</div>
							<div class="col-3">
								<span v-if="readWeightment.ref_no">{{ readWeightment.ref_no }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-3 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Company</label>
							</div>
							<div class="col-3">
								<div>
									<span v-if="readWeightment.company_id">{{ readWeightment.company?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-12">
								<span class="form-label text-uppercase fw-bold m-0 me-3">To Customer</span>
								<span class="form-label text-uppercase fw-bold m-0 me-3 text-primary">"{{ readWeightment.customer?.name }}"</span>
								<span class="form-label text-uppercase fw-bold m-0 me-3">Subject</span>
								<span class="form-label text-uppercase fw-bold m-0 me-3 text-primary">"{{ readWeightment.subject }}"</span>
								<span class="form-label text-uppercase fw-bold m-0 me-3">General Structural Condition</span>
							</div>
						</div>
						<div class="row mb-2 border-bottom pb-2">
							<div class="col-8">
								<span>1. </span>
								<span v-if="readWeightment.field_1_key">{{ readWeightment.field_1_key }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-2">
								<span v-if="readWeightment.field_1_value_1">{{ readWeightment.field_1_value_1 }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-2">
								<span v-if="readWeightment.field_1_value_2">{{ readWeightment.field_1_value_2 }}</span
								><span v-else><i>Not specified</i></span>
							</div>
						</div>
						<div class="row mb-2 border-bottom pb-2">
							<div class="col-8">
								<span>2. </span>
								<span v-if="readWeightment.field_2_key">{{ readWeightment.field_2_key }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-2">
								<span v-if="readWeightment.field_2_value_1">{{ readWeightment.field_2_value_1 }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-2">
								<span v-if="readWeightment.field_2_value_2">{{ readWeightment.field_2_value_2 }}</span
								><span v-else><i>Not specified</i></span>
							</div>
						</div>
						<div class="row mb-2 border-bottom pb-2">
							<div class="col-8">
								<span>3. </span>
								<span v-if="readWeightment.field_3_key">{{ readWeightment.field_3_key }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-2">
								<span v-if="readWeightment.field_3_value_1">{{ readWeightment.field_3_value_1 }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-2">
								<span v-if="readWeightment.field_3_value_2">{{ readWeightment.field_3_value_2 }}</span
								><span v-else><i>Not specified</i></span>
							</div>
						</div>
						<div class="row mb-2 border-bottom pb-2">
							<div class="col-8">
								<span>4. </span>
								<span v-if="readWeightment.field_4_key">{{ readWeightment.field_4_key }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-2">
								<span v-if="readWeightment.field_4_value_1">{{ readWeightment.field_4_value_1 }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-2">
								<span v-if="readWeightment.field_4_value_2">{{ readWeightment.field_4_value_2 }}</span
								><span v-else><i>Not specified</i></span>
							</div>
						</div>
						<div class="row mb-4 border-bottom pb-2">
							<div class="col-8">
								<span>5. </span>
								<span v-if="readWeightment.field_5_key">{{ readWeightment.field_5_key }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-2">
								<span v-if="readWeightment.field_5_value_1">{{ readWeightment.field_5_value_1 }}</span
								><span v-else><i>Not specified</i></span>
							</div>
							<div class="col-2">
								<span v-if="readWeightment.field_5_value_2">{{ readWeightment.field_5_value_2 }}</span
								><span v-else><i>Not specified</i></span>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-3 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Comments</label>
							</div>
							<div class="col-9 pb-2 border-bottom">
								<div>
									<span v-if="readWeightment.comments">{{ readWeightment.comments }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-3 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Surveyor</label>
							</div>
							<div class="col-9 pb-2 border-bottom">
								<div>
									<span v-if="readWeightment.surveyor">{{ readWeightment.surveyor?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-3 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Date Of Issue</label>
							</div>
							<div class="col-9 pb-2 border-bottom">
								<div>
									<span v-if="readWeightment.date_of_issue">{{ formatMySQLDate(readWeightment.date_of_issue, "MMM dd, yyyy") }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-3 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Status</label>
							</div>
							<div class="col-3">
								<div>
									<span class="badge rounded-pill bg-success" v-if="readWeightment.status == 1">ACTIVE</span>
									<span class="badge rounded-pill bg-danger" v-if="readWeightment.status == 0">INACTIVE</span>
								</div>
							</div>
							<div class="col-3 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Created By</label>
							</div>
							<div class="col-3">
								<div>
									<span v-if="readWeightment.creator?.name">{{ readWeightment.creator?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-dark btn-sm" data-bs-dismiss="modal">CLOSE</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Upload Images -->
		<UploadImages :dataprops="uploadDataprops" @refresh-object="refreshObject"></UploadImages>
		<!-- Upload Images -->
	</div>
</template>
<script>
	import {useVuelidate} from "@vuelidate/core";
	import {required, minValue, alphaNum, numeric, email, requiredIf, minLength} from "@vuelidate/validators";
	import * as bootstrap from "bootstrap";
	function initialState() {
		return {
			id: 0,
			ref_no: "",
			company_id: null,
			customer_id: null,
			subject: "",
			field_1_key: "",
			field_1_value_1: "",
			field_1_value_2: "",
			field_2_key: "",
			field_2_value_1: "",
			field_2_value_2: "",
			field_3_key: "",
			field_3_value_1: "",
			field_3_value_2: "",
			field_4_key: "",
			field_4_value_1: "",
			field_4_value_2: "",
			field_5_key: "",
			field_5_value_1: "",
			field_5_value_2: "",
			comments: "",
			surveyor_id: null,
			date_of_issue: "",
			action: ""
		};
	}
	function initialStateValidations() {
		return {
			ref_no: {minLengthValue: minLength(1)},
			company_id: {required},
			customer_id: {required},
			subject: {minLengthValue: minLength(1)},
			field_1_key: {minLengthValue: minLength(1)},
			field_1_value_1: {minLengthValue: minLength(1)},
			field_1_value_2: {minLengthValue: minLength(1)},
			field_2_key: {minLengthValue: minLength(1)},
			field_2_value_1: {minLengthValue: minLength(1)},
			field_2_value_2: {minLengthValue: minLength(1)},
			field_3_key: {minLengthValue: minLength(1)},
			field_3_value_1: {minLengthValue: minLength(1)},
			field_3_value_2: {minLengthValue: minLength(1)},
			field_4_key: {minLengthValue: minLength(1)},
			field_4_value_1: {minLengthValue: minLength(1)},
			field_4_value_2: {minLengthValue: minLength(1)},
			field_5_key: {minLengthValue: minLength(1)},
			field_5_value_1: {minLengthValue: minLength(1)},
			field_5_value_2: {minLengthValue: minLength(1)},
			comments: {minLengthValue: minLength(1)},
			surveyor_id: {},
			date_of_issue: {}
		};
	}
	export default {
		name: "Weightmentmaster",
		props: ["current_user_id", "all_permissions"],
		setup() {
			return {
				v$: useVuelidate()
			};
		},
		data() {
			return {
				dataprops: {
					id: "weightment-list",
					class: "a",
					base_url: this.docRoot+"/api/weightment/",
					columns: [
						{title: "Ref No", property: "ref_no"},
						{title: "Company", property: "company.name"},
						{title: "Customer", property: "customer.name"},
						{title: "Created By", property: "creator.name", alt_value: "Not Specified"}
					],
					data_to_send: {current_user_id: this.current_user_id},
					reload: false,
					search: "simple"
				},
				uploadDataprops: {
					relatedObject: null,
					name: "Weightment"
				},
				addEditModal: null,
				readModal: null,
				currentUser: siteUserObject,
				weightmentForAdd: initialState(),
				readWeightment: {},
				allCompanyIdList: [],
				allCustomerIdList: [],
				allSurveyorIdList: []
			};
		},
		validations() {
			return {
				weightmentForAdd: initialStateValidations()
			};
		},
		methods: {
			cancelAddEdit(event) {
				this.weightmentForAdd = initialState();
				this.v$.$reset();
			},
			duplicateObject(weightment) {
				let that = this;
				this.showConfirm("Are you sure you want to create a duplicate of this record?", "Yes", "No").then((result) => {
					if (result.isConfirmed) {
						this.weightmentForAdd = Object.assign({}, weightment);
						this.weightmentForAdd.id = 0;
						this.weightmentForAdd.ref_no = null;
						this.addEditModal.show();
					}
				});
			},
			async saveWeightment(event) {
				var thisVar = this;
				const result = await this.v$.$validate();
				if (!result) {
					this.showToast("Form validation failed. Please check.", "error", "bottom", 2000);
					console.log(this.v$.$errors);
					return;
				}
				if ( this.weightmentForAdd.surveyor_id != 'null' && typeof this.weightmentForAdd.surveyor_id === 'object' && this.weightmentForAdd.surveyor_id.id) {
					this.weightmentForAdd.surveyor_id = this.weightmentForAdd.surveyor_id.id;
				}
				if ( this.weightmentForAdd.customer_id != 'null' && typeof this.weightmentForAdd.customer_id === 'object' && this.weightmentForAdd.customer_id.id) {
					this.weightmentForAdd.customer_id = this.weightmentForAdd.customer_id.id;
				}
				if (!this.weightmentForAdd.action || this.weightmentForAdd.action == "") this.weightmentForAdd.action = "details";
				this.weightmentForAdd.created_by = this.current_user_id;
				// $("#addWeightmentModal").modal("hide");
				bootstrap.Modal.getInstance(document.getElementById('addWeightmentModal')).hide();
				this.showLoading("Saving ...");
				axios
					.post(this.docRoot+"/weightment/save", {weightment: this.weightmentForAdd})
					.then(async function (response) {
						thisVar.closeSwal();
						var status = response.data.status;
						if (status == 1) {
							// Ajax to submit
							thisVar.showToast("Weightment saved successfully", "success", "bottom", 3000);
							setTimeout(() => {
								thisVar.dataprops.reload = true;
							}, 1500);
							thisVar.weightmentForAdd = initialState();
							thisVar.v$.$reset();
						} else thisVar.showErrors("Weightment could not be saved successfully", response.data.messages, "bottom", 3000);
					})
					.catch(function (error) {
						console.log(error);
						thisVar.closeSwal();
						thisVar.showToast("Weightment could not be saved successfully", "error", "bottom", 3000);
					});
			},
			prepareEditWeightment(weightment) {
				this.weightmentForAdd = Object.assign({}, weightment);
				this.addEditModal.show();
				if (this.weightmentForAdd.surveyor_id) {
					if (Array.isArray(this.allSurveyorIdList) && this.allSurveyorIdList.length > 0) {
						let _allRelationList = this.allSurveyorIdList;
						let relationId = parseInt(this.weightmentForAdd.surveyor_id);
						this.weightmentForAdd.surveyor_id = _allRelationList.find(item => item.id === relationId);
					}
				}
				if (this.weightmentForAdd.customer_id) {
					if (Array.isArray(this.allCustomerIdList) && this.allCustomerIdList.length > 0) {
						let _allRelationList = this.allCustomerIdList;
						let relationId = parseInt(this.weightmentForAdd.customer_id);
						this.weightmentForAdd.customer_id = _allRelationList.find(item => item.id === relationId);
					}
				}
			},
			viewWeightment(weightment) {
				this.readWeightment = weightment;
				this.readModal.show();
			},
			toggleWeightment(weightment, status) {
				var thisVar = this;
				Swal.fire({
					icon: "question",
					html: "Do you really want to " + (status == 1 ? "reactivate" : "deactivate") + ' the Weightment - <br/>"' + weightment.none + '"?',
					showCancelButton: true
				}).then((result) => {
					if (result.isConfirmed) {
						thisVar.weightmentForAdd = weightment;
						thisVar.weightmentForAdd.status = status;
						thisVar.weightmentForAdd.action = "status";
						thisVar.saveWeightment();
					}
				});
			},
			printWeightment(weightment) {
				window.location = this.docRoot + "/weightment/export-to-pdf/" + weightment.id;
				this.showToast("Printing. Please wait ...", "success", "bottom", 3000);
			},
			async uploadImages(weightment) {
				this.showLoading("Loading images ...");
				await this.refreshObject(imo1, "Weightment", 1);
				this.closeSwal();
			},
			displayLabelSetting ({id, text}) {
				return `${text}`;
			},
		},
		async mounted() {
			this.addEditModal = new bootstrap.Modal(this.$refs.addEditModal, {backdrop: "static", keyboard: false});
			this.readModal = new bootstrap.Modal(this.$refs.readModal, {backdrop: "static", keyboard: false});
			this.allCompanyIdList = await this.loadAllCompany(true);
			let _allSurveyorIdList = await this.loadAllSurveyor(true);
			if(Array.isArray(_allSurveyorIdList) && _allSurveyorIdList.length > 0){
				this.allSurveyorIdList = _allSurveyorIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allCustomerIdList = await this.loadAllCustomer(true);
			if(Array.isArray(_allCustomerIdList) && _allCustomerIdList.length > 0){
				this.allCustomerIdList = _allCustomerIdList.map(x => {return { id: x.id, text: x.name }});
			}
		}
	};
</script>
